import { InsightMetric } from '@repo/types';
import { Card, Spinfinity, Typography } from 'components';
import MicrobiomeAgeOverTimeChart from 'components/MicrobiomeAgeOverTimeChart/MicrobiomeAgeOverTimeChart';
import { Suspense } from 'react';
import styles from './MicrobiomeAgeOverTimeCard.module.css';

interface MicrobiomeAgeOverTimeCardProps {
  metric: Partial<InsightMetric>;
}

export default function MicrobiomeAgeOverTimeCard({
  metric,
}: MicrobiomeAgeOverTimeCardProps) {
  return (
    <Card cardBodyClassName={styles.card}>
      <Typography variant={'heading-m'} className='mb-3'>
        Over time
      </Typography>
      <Suspense fallback={<Spinfinity />}>
        <MicrobiomeAgeOverTimeChart metricId={metric?.sample_health_id ?? 0} />
      </Suspense>
    </Card>
  );
}
